import React from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setActiveItem } from "../app/reducers/activePage";

const List = ({ listItem, bgColor }) => {
  const activepage = useSelector((state) => state.activepage);
  const dispatch = useDispatch();
  return (
    <>
      <ul className="flex justify-center items-center   w-full  -mb-[12px] lg:gap-4  z-40     ">
        {listItem?.map((item, index) => {
          return (
            <>
              <Link to={item?.url}>
                <li
                  key={index}
                  className={` p-2 relative    group text-[12px] lg:text-[14px]   cursor-pointer ${
                    activepage === item.name
                      ? " text-[#009932] "
                      : `${
                          bgColor == "black"
                            ? "text-[#aaa8a8]"
                            : "text-[#333333]"
                        }  hover:text-[#009932] transition-all duration-500 ease-in-out `
                  }`}
                >
                  <div className="relative group z-40 ">
                    <div className="flex justify-center items-center   ">
                      <p
                        className=" tracking-wide whitespace-nowrap "
                        onClick={() => {
                          dispatch(setActiveItem(item.name));
                        }}
                      >
                        {item.name}
                      </p>
                      {item.items?.length > 0 && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                          class="ml-1 -mr-1 h-4 w-4 "
                        >
                          <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      )}
                    </div>
                    {item.items?.length > 0 && (
                      <div className="absolute invisible group-hover:visible top-6 border flex flex-col rounded-lg px-2 py-4 shadow-md bg-white  text-[14px] text-[#333333] z-20  ">
                        {item.items?.map((item, index) => {
                          return (
                            <Link to={item?.url}>
                              <p
                                key={index}
                                className="p-2 rounded-lg min-w-[170px] hover:bg-[#f5f5f5]"
                              >
                                {item.name}
                              </p>
                            </Link>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </li>
              </Link>
            </>
          );
        })}
      </ul>
    </>
  );
};

export default List;

{
  /* <span
                  className={`box arrow-top   hover:visible  ${
                    activepage === item.name
                      ? "visible hover:visible"
                      : "invisible group-hover:visible"
                  } `}
                ></span> */
}
